import React from "react";
import styles from "../HealthChat.module.css";
import { useNavigate } from "react-router-dom";

const SuccessCheckmark = () => (
  <div className={styles.checkmarkWrapper}>
    <div className={styles.statusIconCircle}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fff"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </div>
  </div>
);

export default function BookingSuccessScreen({ onCloseChat }) {
  const navigate = useNavigate();

  const handleFinalAction = (path) => {
    if (onCloseChat) onCloseChat();
    navigate(path);
  };

  return (
    <div className={styles.bookingContainer}>
      {/* Top Header Section */}
      <div className={styles.successHeader}>
        <SuccessCheckmark />
        <h2 className={styles.mainTitle}>You're all set! 🎉</h2>
        <p className={styles.subTitle}>Your appointment is confirmed.</p>
      </div>

      {/* Confirmation Card */}
      <div className={styles.appointmentCard}>
        <div className={styles.cardHeader}>
          <img
            src="/Home/5section-2.svg"
            alt="Doctor"
            className={styles.doctorImg}
          />
          <div className={styles.doctorInfo}>
            <h4>Dr. Neha Sharma</h4>
            <span>Gynecologist</span>
          </div>
        </div>

        <div className={styles.cardBody}>
          <div className={styles.dataRow}>
            <span className={styles.label}>Date</span>
            <span className={styles.value}>Tuesday, 21 May 2024</span>
          </div>
          <div className={styles.dataRow}>
            <span className={styles.label}>Time</span>
            <span className={styles.value}>10:00 AM</span>
          </div>
          <div className={styles.dataRow}>
            <span className={styles.label}>Visit type</span>
            <span className={styles.value}>In-clinic visit</span>
          </div>
          <div className={styles.dataRow}>
            <span className={styles.label}>Location</span>
            <span className={styles.value}>
              Avexa Women's Health Clinic
              <br />
              Bangalore, Karnataka
            </span>
          </div>
          <div className={styles.dataRow}>
            <span className={styles.label}>Booking ID</span>
            <span className={styles.valueBold}>AVX12345678</span>
          </div>
        </div>
      </div>

      {/* Notification Box */}
      <div className={styles.infoNotice}>
        We've sent the details to
        <br />
        <span className={styles.highlightText}>riya.mehta@email.com</span> and{" "}
        <span className={styles.highlightText}>+91 98765 43210</span>
      </div>

      {/* Action Buttons */}
      <div className={styles.buttonGroup}>
        <button
          className={styles.visitModelContinueBtn}
          onClick={() => handleFinalAction("/book-appointment")}
        >
          View my appointments
        </button>
        <button
          className={styles.OutlinedContinueBtn}
          onClick={() => handleFinalAction("/")}
        >
          Go to home
        </button>
      </div>
    </div>
  );
}